import Tracking from '~/components/Abstracts/Tracking'
import Search, { SearchProps } from '~/components/Search'

import getSearchPageStaticPropsFunction from '~/data/search-page-data'

function SearchPage(props: SearchProps) {
  return (
    <>
      <Search {...props} />
      <Tracking template="search" />
    </>
  )
}

export default SearchPage

export const getStaticProps = getSearchPageStaticPropsFunction()
